export default __webpack_public_path__ + "static/media/board_selector_bg.2af3dd1c.png";